import { forwardRef } from 'react';

import {
  Center,
  Text,
  VisuallyHidden,
  type CenterProps,
} from '@frontend/components';

type AssemblyBadgeProps = CenterProps & {
  size: 'sm' | 'md';
};

export const AssemblyBadge = forwardRef(
  ({ size, ...restProps }: AssemblyBadgeProps, ref) => {
    return (
      <Center
        ref={ref}
        position="absolute"
        borderRadius="2px"
        background="interaction.main"
        w={size === 'md' ? 3 : '14px'}
        h={size === 'md' ? 3 : '14px'}
        right={size === 'md' ? '5px' : '1px'}
        bottom={size === 'md' ? '5px' : '1px'}
        {...restProps}
      >
        <Center>
          <Text
            fontSize={size === 'md' ? '12px' : '10px'}
            fontWeight="heavy"
            color="feature.onInteraction"
            lineHeight={size === 'md' ? '18px' : '16px'}
            aria-hidden="true"
          >
            A
          </Text>
          <VisuallyHidden>Assembly</VisuallyHidden>
        </Center>
      </Center>
    );
  },
);
AssemblyBadge.displayName = 'AssemblyBadge';
